import React from 'react';
import { Box } from '@mui/material';

const TeamWhiteBackgroundContainer = ({ children }) => {
  return (
    <Box
      sx={{
        backgroundColor: 'white',
        borderRadius: '14px',
        boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.05)', // Very subtle and smudgy shadow
        px: 2,
        py: 2,
        mt: 1, // Adding margin-top for spacing from the heading
      }}
    >
      {children}
    </Box>
  );
};

export default TeamWhiteBackgroundContainer;